import React, { useState } from 'react';

import { normalizeApiError } from '../services/apiError';
import { promotionService, type ShareItem } from '../services/promotionService';

import { QuotaQueueNotice } from './QuotaQueueNotice';

/** Try again on a reel held for its plan's hourly quota: the share now, with the new wait if still spent. */
export const retryHeldShare = async (share: ShareItem): Promise<ShareItem> => {
  try {
    return await promotionService.retryShare(share.id);
  } catch (error) {
    const info = normalizeApiError(error).quotaQueue;

    return info ? { ...share, quota_queue: info } : promotionService.getShare(share.id).catch(() => share);
  }
};

/** Nothing sends a held reel again by itself: Try again does, once the plan's hourly quota has room. */
export const HeldReelNotice: React.FC<{ share: ShareItem; onChange: (share: ShareItem) => void }> = ({
  share, onChange,
}) => {
  const [busy, setBusy] = useState(false);
  const retry = async () => {
    setBusy(true);
    onChange(await retryHeldShare(share));
    setBusy(false);
  };

  return share.quota_queue ? (
    <QuotaQueueNotice source="reels:held-quota" notice={share.quota_queue}
      action={{ label: 'Try again', onClick: () => { void retry(); }, busy }} />
  ) : null;
};
